import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { fade } from '../animation'

const Wave = () => {
	return (
		<WaveSvg
			viewBox='0 0 1384 539'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<motion.path
				variants={fade}
				initial={{ pathLength: 0, pathOffset: 1, opacity: 0 }}
				animate={{ pathLength: 1, pathOffset: 0 }}
				transition={{ duration: 3 }}
				d='M106 79L139 91M106 79L135 110M106 79L153 23M106 79L83 47M139 91L135 110M139 91L153 23M139 91L284 114M135 110L224 142M135 110L169 122M135 110L163 156M153 23L83 47M153 23L188 99M153 23L241 58M153 23L1 1L83 47M284 114L169 122M284 114L224 142M284 114L248 198M284 114V170M284 114L342 189M284 114L241 58M284 114L188 99M224 142L169 122M224 142L248 198M224 142L205 170M224 142L163 156M248 198L205 170M248 198L284 170M248 198L309 245M284 170L342 189M284 170L309 245M205 170L163 156M342 189L309 245M342 189L364 245M342 189L375 180.04M309 245H364M309 245L342 293M364 245L342 293M364 245L375 180.04M364 245L413.266 230M364 245L446.601 249.736M342 293L455 281M342 293L449 314M342 293L446.601 249.736M375 180.04L425 170M375 180.04L413.266 201M413.266 230V201M413.266 230L528 214M413.266 230L446.601 249.736M413.266 230L484 236M413.266 230L473.133 207.5M425 170L413.266 201M425 170L528 214M425 170L473.133 207.5M413.266 201L473.133 207.5M528 214L455 281M528 214L484 236M528 214L473.133 207.5M455 281L449 314M455 281L501 314M455 281L446.601 249.736M455 281L484 236M449 314H501M449 314L496 359M501 314L496 359M501 314L542 339M496 359L542 339M496 359H623M542 339L623 359M623 359L581 386.5M623 359L616.329 474M623 359L596.243 400.091M581 423.5V386.5M581 423.5L652 400.091M581 423.5L616.329 474M581 423.5L596.243 400.091M581 423.5L616.329 413M581 386.5L596.243 400.091M652 400.091L616.329 474M652 400.091L641 494M652 400.091L698 474M652 400.091L710 451L775 511M652 400.091L616.329 413M616.329 474L641 494M616.329 474L641 528M641 494L698 474M641 494V528M698 474L775 511M698 474L641 528M775 511H1032M775 511L802.5 423.5M775 511L861 474M775 511L641 528M775 511L747 528H641M1032 511L861 474M1032 511L802.5 423.5M1032 511L915 324M1032 511L902 423.5M802.5 423.5L861 474M802.5 423.5L839 381M915 324L847 309M915 324L1000 291M915 324L902 423.5M839 381L902 423.5M839 381L824.091 321.282M847 309L1000 291M847 309L922 272M847 309L824.091 321.282M847 309L902 423.5M1000 291L922 272M1000 291L861 219M1000 291L944 225M922 272L831.75 242M922 272L824.091 321.282M861 219L831.75 242M861 219L817 189M861 219L944 225M831.75 242L817 189M817 189L866 201.5M944 225L1021 187.812M944 225L866 201.5M1021 187.812H902M1021 187.812L927 129M1021 187.812L968 98M866 201.5L886 156L902 187.812M866 201.5L902 187.812M902 187.812L927 129M927 129L968 98M927 129L968 29M968 98V29M968 98H1082M968 98L1101 60M968 29L1015 69M968 29L1021 41M968 29L1121 8M241 58L188 99M446.601 249.736L484 236M1082 98L1015 69M1082 98L1101 60M1021 41L1015 69M1021 41L1101 60M1021 41L1121 8M1015 69L1101 60M1101 60L1121 8M1101 60L1146 19M1101 60L1189 98M1101 60L1232 118M1121 8L1146 19M1146 19L1189 98M1146 19L1189 47M1146 19L1216 13M1189 98V47M1189 98L1232 118M1189 47L1232 118M1189 47L1216 13M1189 47L1244 35M1189 47L1259 98M1232 118L1259 98M1232 118L1359 124.058M1216 13L1244 35M1244 35L1259 98M1244 35L1326 98.5023M902 423.5L824.091 321.282M596.243 400.091L616.329 413M1259 98L1359 124.058M1259 98L1326 98.5023M1359 124.058L1346 172L1382.05 156L1359 124.058ZM1359 124.058L1326 98.5023'
				stroke='#E9FA03'
				strokeOpacity='0.5'
				strokeWidth='1'
			/>
		</WaveSvg>
	)
}

const WaveSvg = styled.svg`
	position: absolute;
	left: 0;
	top: 16%;
	object-fit: cover;
	z-index: -1;

	@media (max-width: 540px) {
		display: none;
	}
	@media (min-width: 541px) {
		top: 23%;
	}
	@media (min-width: 768px) {
		top: 20%;
	}
	@media (min-width: 901px) {
		top: 14%;
	}
	@media (min-width: 1200px) {
		top: 15%;
	}
`

export default Wave
